/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ServiceTypeEnum } from './serviceTypeEnum';
import { DeploymentComponent } from './deploymentComponent';


export interface ReleaseRegionData { 
    /**
     * Version Sting
     */
    version: string;
    service_type: ServiceTypeEnum;
    default_version: boolean;
    components: Array<DeploymentComponent>;
}
export namespace ReleaseRegionData {
}


